import React, { useCallback, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { readUserSession } from '../Auth/userSession';
import { getInquiry } from './myPageApi';
import { inquiryStatusLabels } from './inquiryStatus';

// 문의 상세 화면: 내가 쓴 문의 내용과 답변(있으면)을 보여준다.
export default function InquiryDetailSection() {
    const { inquiryId } = useParams();
    const [inquiry, setInquiry] = useState(null);
    const [error, setError] = useState('');

    // 문의 상세를 불러온다.
    const load = useCallback(async () => {
        setError('');
        setInquiry(null);
        try {
            setInquiry(await getInquiry(inquiryId));
        } catch (loadError) {
            setError(loadError.message);
        }
    }, [inquiryId]);

    useEffect(() => { load(); }, [load]);

    const back = <Link className="my-page-back-link" to="/mypage/inquiry">← 문의 목록</Link>;
    if (error) return <>{back}<div className="my-page-card my-page-placeholder" role="alert"><h3>문의 내역을 불러오지 못했습니다</h3><p>{error}</p><button type="button" className="my-page-button my-page-retry" onClick={load}>다시 시도</button></div></>;
    if (!inquiry) return <>{back}<p className="my-page-notice" role="status">문의 내역을 불러오고 있습니다.</p></>;

    const answered = inquiry.status === 'answered';
    // 본인 문의만 조회되므로 작성자는 로그인한 사용자다.
    const authorEmail = readUserSession()?.user?.email;
    return <>
        {back}
        <article className="my-page-card my-page-inquiry-detail">
            <div className="my-page-inquiry-detail-head"><h3>{inquiry.title}</h3><span className={`my-page-inquiry-status${answered ? ' done' : ''}`}>{inquiryStatusLabels[inquiry.status] || inquiry.status || '—'}</span></div>
            <span className="my-page-meta">{inquiry.created_at}</span>
            {authorEmail && <span className="my-page-meta">{authorEmail}</span>}
            <p className="my-page-inquiry-body">{inquiry.content}</p>
        </article>
        {answered && inquiry.answer ? <section className="my-page-card my-page-inquiry-detail my-page-inquiry-answer">
            <h3>답변</h3>
            {inquiry.answered_at && <span className="my-page-meta">{inquiry.answered_at}</span>}
            <p className="my-page-inquiry-body">{inquiry.answer}</p>
        </section> : <div className="my-page-card my-page-placeholder my-page-inquiry-answer"><h3>답변을 준비하고 있습니다</h3><p>답변이 등록되면 이곳에서 확인할 수 있습니다.</p></div>}
    </>;
}
